import { render, staticRenderFns } from "./TotalBoardsTasks.vue?vue&type=template&id=22323b36&"
import script from "./TotalBoardsTasks.vue?vue&type=script&lang=js&"
export * from "./TotalBoardsTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports